import React from 'react';
import bitmapBackground from 'assets/images/bitmap-background.png';
import MainLayout, { MainLayoutProps } from 'components/layout/MainLayout';
import { AppRoutes, ButtonTypes } from 'types';

interface ActivitiesLayout extends MainLayoutProps {
  assignmentId: number;
  children: React.ReactNode | any;
  showHelpButton?: boolean;
}

const ActivitiesLayout: React.FC<ActivitiesLayout> = ({
  assignmentId,
  children,
  footerProps,
  menuProps = {},
  showHelpButton = true,
  ...rest
}) => {
  const { children: footerChildren, ...restfooterProps } = footerProps ?? {};
  const { children: headerChildren } = menuProps;
  return (
    <MainLayout
      backgroundImg={bitmapBackground}
      menuProps={{
        primaryLeftButton: { name: ButtonTypes.HOME_BUTTON },
        children: headerChildren,
        secondaryLeftButton: assignmentId
          ? {
              name: ButtonTypes.BACK_BUTTON,
              redirectRoute: {
                path: `/${AppRoutes.ASSIGNMENTS}/${assignmentId}`,
                title: AppRoutes.ASSIGNMENTS as any,
              },
            }
          : undefined,
      }}
      footerProps={{
        children: footerChildren,
        ...(showHelpButton
          ? {
              primaryLeftButton: {
                name: ButtonTypes.MAT_MAN_ACTIVITY_BUTTON,
              },
            }
          : {}),
        ...restfooterProps,
      }}
      {...rest}
    >
      {children}
    </MainLayout>
  );
};

export default ActivitiesLayout;
